import React from 'react';
import { useTranslations } from '../../localization/useTranslations';
import { PremiumButtonProps } from '../types/NavigationLink';

const PremiumButton: React.FC<PremiumButtonProps> = ({ url, isPremium }) => {
  const translations = useTranslations();
  return (
    <a href={url} className="account-dropdown__button--link">
      <button
        className={`account-dropdown__button account-dropdown__button--${
          isPremium ? 'extend' : 'upgrade'
        } button button--secondary button--medium button--icon-before`}
      >
        {isPremium
          ? translations?.premiumButton.extendButton || 'Extend'
          : translations?.premiumButton.upgradeButton || 'Upgrade'}
      </button>
    </a>
  );
};

export default PremiumButton;
